export const storefront = {
  header: {
    brandFallback: 'Tickets',
    conferences: 'Conferences',
    about: 'About',
    myTickets: 'My Tickets',
    profile: 'Profile',
    memberships: 'Memberships',
    signOut: 'Sign Out',
    signIn: 'Sign In',
    register: 'Register',
  },
  footer: {
    needHelp: 'Need help? Contact the organiser.',
    explore: 'Explore',
    events: 'Courses',
    about: 'About',
    myTickets: 'My Tickets',
    help: 'Help',
    helpBody: 'Questions about your booking? Contact the organiser directly and include your order reference.',
    allRightsReserved: 'All rights reserved.',
    poweredBy: 'Powered by Selwyn',
  },
  eventList: {
    loading: 'Loading courses...',
    title: 'Upcoming Courses',
    searchPlaceholder: 'Search courses…',
    gridViewTitle: 'Grid view',
    calendarViewTitle: 'Calendar view',
    dateFilterAll: 'All',
    dateFilterWeek: 'This week',
    dateFilterMonth: 'This month',
    categoryAll: 'All',
    errorTitle: 'Could not load courses',
    errorBody: 'Please try again later.',
    noEventsTitle: 'No courses found',
    noEventsFiltered: 'Try a different search or filter.',
    noEventsEmpty: 'Check back soon for upcoming courses.',
    soldOut: 'Sold Out',
    ticketsLeft: '{count} left',
    datesCount: '{count} dates',
    getTickets: 'Get Tickets',
    view: 'View',
  },
  eventDetail: {
    loading: 'Loading course...',
    notFoundTitle: 'Course not found',
    notFoundBody: 'This course does not exist or is no longer available.',
    backToEvents: 'Back to Courses',
    allEvents: 'All Courses',
    share: 'Share',
    linkCopied: 'Link copied!',
    copyLink: 'Copy link to clipboard',
    addToCalendar: 'Add to Calendar',
    icalOutlook: 'iCal / Outlook',
    googleCalendar: 'Google Calendar',
    onlineEventLabel: 'Online Course',
    whoIsAttending: "Who's attending",
    loginRequiredBody: "The attendee list is only visible to ticket holders. Log in to see who's coming.",
    loginToView: 'Log in to view',
    ticketRequiredBody: 'The attendee list is only visible to confirmed ticket holders.',
    attendingCountOne: '{count} person attending',
    attendingCountMany: '{count} people attending',
    hiddenCountOne: '+{count} person has chosen not to display their profile.',
    hiddenCountMany: '+{count} people have chosen not to display their profile.',
    clickToSeeMore: 'Click to see more',
    web: 'Web',
    linkedin: 'LinkedIn',
    tapToExpand: 'tap to expand',
    free: 'Free',
    getTickets: 'Get Tickets',
    pricePerTicket: '{price} per ticket',
    memberPriceApplied: 'Member price applied — non-members pay {price}',
    nonMemberPriceNote: 'Members pay {price} — log in with a membership to see your rate',
    selectDate: 'Select date',
    chooseADate: 'Choose a date…',
    pleaseChooseDate: 'Please choose a date to continue.',
    ticketCount: '{count} ticket{plural}',
    soldOut: 'Sold out',
    soldOutButton: 'Sold Out',
    onlyXLeft: 'Only {count} ticket{plural} left!',
    ticketsRemaining: '{count} tickets remaining',
    quantity: 'Quantity',
    total: 'Total:',
    continueToCheckout: 'Continue to Checkout',
    waitlistPrompt: 'Want to join the waitlist? Contact the organiser:',
    signInPrompt: "You'll be asked to sign in or create an account.",
    moreEventsLikeThis: 'More courses like this',
  },
  conferenceList: {
    loading: 'Loading conferences...',
    title: 'Upcoming Conferences',
    searchPlaceholder: 'Search conferences…',
    errorTitle: 'Could not load conferences',
    errorBody: 'Please try again later.',
    noConferencesTitle: 'No conferences found',
    noConferencesFiltered: 'Try a different search.',
    noConferencesEmpty: 'Check back soon for upcoming conferences.',
    soldOut: 'Sold Out',
    sessionsCount: '{count} sessions',
    getPass: 'Get Pass',
    view: 'View',
  },
  conferenceDetail: {
    loading: 'Loading conference...',
    notFoundTitle: 'Conference not found',
    notFoundBody: 'This conference does not exist or is no longer available.',
    backToConferences: 'Back to Conferences',
    allConferences: 'All Conferences',
    scheduleTitle: 'Schedule',
    generalSchedule: 'General Schedule',
    live: 'Live',
    getPass: 'Get Your Pass',
    passPrice: '{price} per pass',
    passIncludes: 'One pass covers every session in this conference — no need to book each one separately.',
    onlyXLeft: 'Only {count} passes left!',
    soldOutButton: 'Sold Out',
    continueToCheckout: 'Continue to Checkout',
    signInPrompt: "You'll be asked to sign in or create an account.",
  },
  checkout: {
    loading: 'Preparing your order...',
    errorTitle: 'Could not start checkout',
    goBack: 'Go Back',
    back: 'Back',
    title: 'Checkout',
    couponTitle: 'Got a coupon code?',
    couponPlaceholder: 'Enter code…',
    couponInvalid: 'Invalid or expired coupon code.',
    proceedToPayment: 'Proceed to Payment',
    proceedErrorInit: 'Could not initialise payment. Please try again.',
    proceedErrorGeneric: 'Something went wrong. Please try again.',
    invalidLink: 'Invalid checkout link.',
    initError: 'Something went wrong. Please go back and try again.',
    paymentFailed: 'Payment could not be completed. Please try again.',
    paymentDetails: 'Payment Details',
    couponApplied: 'Coupon applied — {amount} off',
    payButton: 'Pay {amount}',
    paymentNotConfigured: 'Payments are not configured for this course. Please contact the organiser.',
    ticketsCount: '{count} ticket{plural}',
    conferencePass: 'Conference pass',
    couponDiscount: 'Coupon discount: −{amount}',
    total: 'Total: {amount}',
    orderRefLabel: 'Order ref:',
  },
  orderConfirmation: {
    loading: 'Loading your order...',
    errorTitle: 'Order not found',
    errorBody: "We couldn't find your order. Check your tickets below.",
    viewMyTickets: 'View My Tickets',
    tapToClose: 'Tap anywhere to close',
    title: 'Booking Confirmed!',
    subtitle: 'Your tickets have been booked. See you there!',
    ticketsCount: '{count} ticket{plural}',
    orderRefLabel: 'Order ref:',
    yourTicket: 'Your ticket',
    yourTicketOf: 'Your ticket (1 of {count})',
    tapToEnlarge: 'Tap to enlarge · Show this at the door',
    allTicketsAvailable: 'All {count} tickets available in My Tickets',
    share: 'Share',
    linkCopied: 'Link copied!',
    shareEventPage: 'Share course page',
    browseMoreEvents: 'Browse more courses',
  },
  calendar: {
    today: 'Today',
    moreCount: '+{count} more',
    mon: 'Mon',
    tue: 'Tue',
    wed: 'Wed',
    thu: 'Thu',
    fri: 'Fri',
    sat: 'Sat',
    sun: 'Sun',
  },
};
